import { render, staticRenderFns } from "./ReducedPriceComparison.vue?vue&type=template&id=8acf9ea4&scoped=true"
import script from "./ReducedPriceComparison.vue?vue&type=script&lang=ts"
export * from "./ReducedPriceComparison.vue?vue&type=script&lang=ts"
import style0 from "./ReducedPriceComparison.vue?vue&type=style&index=0&id=8acf9ea4&prod&lang=sass&scoped=true"
import style1 from "./ReducedPriceComparison.vue?vue&type=style&index=1&id=8acf9ea4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acf9ea4",
  null
  
)

export default component.exports